
import { environment } from '../../../../../environments/environment';

import { Injectable, Pipe, PipeTransform, NO_ERRORS_SCHEMA } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {

  constructor() { }
  public app = environment.app;
  public userLanguage = "_GERMAN";
  // public userLanguage = "_ENGLISH";
  private defaultLanguage = "_GERMAN";
  private _swizLocaleCodes = [
    { id: 'English', lc: ["en", "en_au", "en_ca", "en_in", "en_ie", "en_mt", "en_nz", "en_ph", "en_sg", "en_za", "en_gb", "en_us"] },
    { id: 'French', lc: ['fr', 'fr_ch'] },
    { id: 'German', lc: ['de', 'de_ch'] },
    { id: 'Italian', lc: ['it', 'it_ch'] }
  ];

  public KEYS = {
    COACH: {
      signup: "signup",
      login: 'login',
      enter_phone_number: 'enter_phone_number',
      next: 'next',
      verify_phone_number: 'verify_phone_number',
      enter_code_sent_to_your_phone: 'enter_code_sent_to_your_phone',
      search_for_studentname_subject: 'search_for_studentname_subject',
      session_history: 'session_history',
      earnings: 'earnings',
      session_trend: 'session_trend',
      earnings_trends: 'earnings_trends',
      alerts: 'alerts',
      about_avidii: 'about_avidii',
      profile_and_payment_details: 'profile_and_payment_details',
      invite_coaches: 'invite_coaches',
      resources: 'resources',
      account_settings: 'account_settings',
      learn_more: 'learn_more',
      terms_and_condition: 'terms_and_condition',
      privacy_and_policy: 'privacy_and_policy',
      mobile_notifications_for_new_coaching_alert: 'mobile_notifications_for_new_coaching_alert',
      email_notifications_for_new_coaching_alert: 'email_notifications_for_new_coaching_alert',
      logout: 'logout',
      coaching_request_alert: 'coaching_request_alert',
      avidii_tune: 'avidii_tune',
      custom: 'custom',
      email_and_phone_notifications: 'email_and_phone_notifications',
      my_profile: 'my_profile',
      back: 'back',
      firstname: 'firstname',
      save_changes: 'save_changes',
      bank_name: 'bank_name',
      account_name: 'account_name',
      iban_number: 'iban_number',
      payment_details: 'payment_details',
      hobbies_and_interests: 'hobbies_and_interests',
      edit: 'edit',
      lastname: 'lastname',
      select_languages_spoken: 'select_languages_spoken',
      address: 'address',
      subjects_taught: 'subjects_taught',
      select_subjects_taught: 'select_subjects_taught',
      profile_details: 'profile_details',
      upload_profile_picture: 'upload_profile_picture',
      enter_bank_name: 'enter_bank_name',
      house_number: 'house_number',
      street_name: 'street_name',
      city: 'city',
      zipcode: 'zipcode',
      country: 'country',
      loading_common: 'loading_common',
      privacy: 'privacy',
      terms: 'terms',
      done: 'done',
      and: 'and',
      by_signing_up_i_agree_to: 'by_signing_up_i_agree_to',
      rate_experience: 'rate_experience',
      session_feedback: 'session_feedback',
      session_experience: 'session_experience',
      student_feedback: 'student_feedback',
      overall_rating: 'overall_rating',
      sessions: 'sessions',
      setup_profile: 'setup_profile',
      german: 'german',
      english: 'english',
      french: 'french',
      italian: 'italian',
      physics: 'physics',
      chemistry: 'chemistry',
      geography: 'geography',
      maths: 'maths',
      biology: 'biology',
      history: 'history',
      accept: 'accept',
      decline: 'decline',
      level: 'level',
      subject: 'subject',
      question_mode: 'question_mode',
      new_coach_request: 'new_coach_request',
      invalid_phone_number: 'invalid_phone_number',
      select_hobbies_description: 'select_hobbies_description',
      add_more_hobbies: 'add_more_hobbies',
      enter_hobbies: 'enter_hobbies',
      select_hobbies: 'select_hobbies',
      Tennis: 'Tennis',
      Reading: 'Reading',
      Movies: 'Movies',
      Puzzles: 'Puzzles',
      Running: 'Running',
      Yoga: 'Yoga',
      Painting: 'Painting',
      Surfing: 'Surfing',
      Trekking: 'Trekking',
      Space: 'Space',
      Workouts: 'Workouts',
      Carpentry: 'Carpentry',
      Origami: 'Origami',
      Knitting: 'Knitting',
      Cooking: 'Cooking',
      Volunteer: 'Volunteer',
      please_wait_while_loading: 'please_wait_while_loading',
      additional_comments: 'additional_comments',
      failed_otp: 'failed_otp',
      server_error: 'server_error',
      invalid_otp: 'invalid_otp',
      primary_school: 'primary school',
      middle_school: 'middle school',
      high_school: 'high school',
      _primary_school: 'primary_school',
      _middle_school: 'middle_school',
      _high_school: 'high_school',
      all_levels: 'all_levels',
      session_is_in_progress_in_new_window: 'session_is_in_progress_in_new_window',
      thanks_for_registering: 'thanks_for_registering',
      end: 'end',
      register_first: 'register_first',
      other: 'other'
    },
    STUDENT: {
      signup: 'signup',
      login: 'login',
      enter_email_or_phone_number: 'enter_email_or_phone_number',
      next: 'next',
      by_signing_up_i_agree_to: 'by_signing_up_i_agree_to',
      or_login_with_social_media: 'or_login_with_social_media',
      dont_have_any_of_the_above: 'dont_have_any_of_the_above',
      username: 'username',
      password: 'password',
      new_user: 'new_user',
      forgot_username_password: 'forgot_username_password',
      scan: 'scan',
      upload: 'upload',
      take_a_picture: 'take_a_picture',
      record: 'record',
      setup_profile: 'setup_profile',
      firstname: 'firstname',
      lastname: 'lastname',
      create_password: 'create_password',
      enter_password: 'enter_password',
      confirm_password: 'confirm_password',
      back: 'back',
      select_username: 'select_username',
      brew_another_name: 'brew_another_name',
      profile_set_up: 'profile_set_up',
      select_an_avatar: 'select_an_avatar',
      date_of_birth: 'date_of_birth',
      educational_level: 'educational_level',
      select_your: 'select_your',
      invite_your_parent: 'invite_your_parent',
      session_history: 'session_history',
      alerts: 'alerts',
      my_profile: 'my_profile',
      profile_details: 'profile_details',
      profile_parents_themes: 'profile_parents_themes',
      about_avidii: 'about_avidii',
      about_terms_privacy: 'about_terms_privacy',
      invite_friends: 'invite_friends',
      resources: 'resources',
      logout: 'logout',
      parent_info: 'parent_info',
      language: 'language',
      account_balance: 'account_balance',
      topup: 'topup',
      invite: 'invite',
      privacy: 'privacy',
      terms_and_conditions: 'terms_and_conditions',
      done: 'done',
      and: 'and',
      confirm_picture: 'confirm_picture',
      retake_picture: 'retake_picture',
      new_session: 'new_session',
      select_subject: 'select_subject',
      physics: 'physics',
      chemistry: 'chemistry',
      geography: 'geography',
      maths: 'maths',
      biology: 'biology',
      history: 'history',
      languages: 'languages',
      select_language: 'select_language',
      german: 'german',
      english: 'english',
      french: 'french',
      italian: 'italian',
      other: 'other',
      solved_problem: 'solved_problem',
      rate_coach: 'rate_coach',
      rate_experience: 'rate_experience',
      terms: 'terms',
      primary_school: 'primary school',
      middle_school: 'middle school',
      high_school: 'high school',
      invite_parent: 'invite_parent',
      please_add_mobile_number: 'please_add_mobile_number',
      invite_parent_info: 'invite_parent_info',
      parent_phone_number: 'parent_phone_number',
      loading_common: 'loading_common',
      finding_coach_waiting: 'finding_coach_waiting',
      finding_coach: 'finding_coach',
      cancel: 'cancel',
      please_wait_while_loading: 'please_wait_while_loading',
      verify_phone_number: 'verify_phone_number',
      start_session: 'start_session',
      start_session_title: 'start_session_title',
      experience_alert: 'experience_alert',
      invalid_password: 'invalid_password',
      parent_invite_sent: 'parent_invite_sent',
      invalid_phone_number: 'invalid_phone_number',
      live_session: 'live_session',
      end: 'end',
      failed_otp: 'failed_otp',
      server_error: 'server_error',
      invalid_otp: 'invalid_otp',
      rate_your_exp_with: 'rate_your_exp_with',
      rate_your_exp: 'rate_your_exp',
      select_country: 'select_country',
      enter_code: 'enter_code',
      coach_not_found: 'coach_not_found',
      coach_found: 'coach_found',
      coach_not_found_for_session: 'coach_not_found_for_session',
      got_coach_request: 'got_coach_request',
      subject: 'subject',
      confirmation: 'confirmation',
      continue: 'continue',
      select_topup_amount: 'select_topup_amount',
      not_eligible: 'not_eligible',
      search: 'search',
      sort: 'sort',
      chat_support: 'chat_support',
      required_email_or_phone_number: 'required_email_or_phone_number',
      no_continue: 'no_continue',
      yes_ok: 'yes_ok',
      invalid_coin_code: 'invalid_coin_code',
      enter_coin_code: 'enter_coin_code',
      ask_code: 'ask_code',
      goto_sessions: 'goto_sessions',
      no_free_sessions: 'no_free_sessions',
      session_is_in_progress_in_new_window: 'session_is_in_progress_in_new_window',
      Tennis: 'Tennis',
      Reading: 'Reading',
      Movies: 'Movies',
      Puzzles: 'Puzzles',
      Running: 'Running',
      Yoga: 'Yoga',
      Painting: 'Painting',
      Surfing: 'Surfing',
      Trekking: 'Trekking',
      Space: 'Space',
      Workouts: 'Workouts',
      Carpentry: 'Carpentry',
      Origami: 'Origami',
      Knitting: 'Knitting',
      Cooking: 'Cooking',
      Volunteer: 'Volunteer',
      notificaton_permission: 'notificaton_permission',
      register_first: 'register_first'
    },

  }
  public PAGES = {
    COACH: {
      common: 'common',
      register: "register",
      verify: 'verify',
      session_history: 'session_history',
      earnings: 'earnings',
      alerts: 'alerts',
      my_profile: 'my_profile',
      about_avidii: 'about_avidii',
      account_settings: 'account_settings',
      profile_and_payment_details: 'profile_and_payment_details',
      session_feedback: 'session_feedback',
      new_coach_request: 'new_coach_request',
      hobbies: 'hobbies',
      whiteboard: 'whiteboard'
    },
    STUDENT: {
      common: 'common',
      register: "register",
      login: "login",
      scan_picture: 'scan_picture',
      setup_profile: 'setup_profile',
      create_password: 'create_password',
      select_username: 'select_username',
      select_avatar: 'select_avatar',
      select_dob: 'select_dob',
      invite_parent: 'invite_parent',
      session_history: 'session_history',
      alerts: 'alerts',
      my_profile: 'my_profile',
      profile_details: 'profile_details',
      edit_hobbies: 'edit_hobbies',
      confirm_picture: 'confirm_picture',
      new_session: 'new_session',
      language_selector: 'language_selector',
      rate_experience: 'rate_experience',
      liveboard: 'liveboard',
      hobbies: 'hobbies'
    }
  }
  public LOCALIZATION_KEYWORDS = {
    STUDENT: {
      common: {
        chat_support: {
          _ENGLISH: "Chat with Avidii",
          _GERMAN: "Hilfe im Chat"
        },
        search: {
          _ENGLISH: "Search",
          _GERMAN: "Suchen"
        },
        sort: {
          _ENGLISH: "Sort",
          _GERMAN: "Sortieren"
        },
        not_eligible: {
          _ENGLISH: "Sorry, looks like you are not eligible to use avidii... But thanks for checking us out!",
          _GERMAN: "Sorry, es sieht so aus, dass du nicht alt genug für avidii....aber cool dass du probiert hast!"
        },
        continue: {
          _ENGLISH: "Continue",
          _GERMAN: "Los",
        },
        select_country: {
          _ENGLISH: "Select Country",
          _GERMAN: "Land auswählen",
        },
        failed_otp: {
          _ENGLISH: "Failed to Send OTP",
          _GERMAN: "hmm, der Code konnte leider nicht gesendet werden.",
        },
        server_error: {
          _ENGLISH: "Server error, please try after some time",
          _GERMAN: "hmm, etwas hat nicht geklappt. Bitte versuch es später nochmal",
        },
        invalid_otp: {
          _ENGLISH: "Invalid Otp, please try again",
          _GERMAN: "hmm, der Code konnte leider nicht gesendet werden. Bitte versuch es nochmal",
        },
        cancel: {
          _ENGLISH: "Cancel",
          _GERMAN: "Abbrechen",
        },
        and: {
          _ENGLISH: "and",
          _GERMAN: "und",
        },
        next: {
          _ENGLISH: "Next",
          _GERMAN: "Weiter",
        },
        back: {
          _ENGLISH: "Back",
          _GERMAN: "Zurück",
        },
        profile_set_up: {
          _ENGLISH: "Profile Set Up",
          _GERMAN: "Profil erstellen"
        },
        date_of_birth: {
          _ENGLISH: "Date of Birth",
          _GERMAN: "Geburtsdatum"
        },
        educational_level: {
          _ENGLISH: "Education level",
          _GERMAN: "Schulstufe"
        },
        primary_school: {
          _ENGLISH: "Primary School",
          _GERMAN: "Primarschule"
        },
        middle_school: {
          _ENGLISH: "Middle School",
          _GERMAN: "Sek / 1-2 Langgymi"
        },
        high_school: {
          _ENGLISH: "High School",
          _GERMAN: "Kurzgymi / 3-6 Langgymi"
        },
        select_your: {
          _ENGLISH: "Select your",
          _GERMAN: "Wähle"
        },
        profile_details: {
          _ENGLISH: "Profile Details",
          _GERMAN: "Profil Details"
        },
        username: {
          _ENGLISH: "User Name",
          _GERMAN: "Benutzername"
        },
        invite: {
          _ENGLISH: "Invite",
          _GERMAN: "einladen"
        },
        about_avidii: {
          _ENGLISH: "About Avidii",
          _GERMAN: "Über avidii"
        },
        privacy: {
          _ENGLISH: "Privacy",
          _GERMAN: "Datenschutz"
        },
        terms_and_conditions: {
          _ENGLISH: "Terms and Conditions",
          _GERMAN: "Terms of Service"
        },
        done: {
          _ENGLISH: "Done",
          _GERMAN: "Fertig"
        },
        loading_common: {
          _ENGLISH: 'Loading... Please wait...',
          _GERMAN: "Lädt... Bitte warten"
        },
        invite_parent: {
          _ENGLISH: "Invite Parent",
          _GERMAN: "Eltern einladen"
        },
        please_wait_while_loading: {
          _ENGLISH: "Please wait while loading...",
          _GERMAN: "Bitte warten während es lädt...",
        },
        invalid_phone_number: {
          _ENGLISH: "please enter valid phone number",
          _GERMAN: "Hmm... Sieht nicht nach einer richtigen Nummer aus",
        },
        subject: {
          _ENGLISH: "Subject",
          _GERMAN: "Schulfach"
        },
      },
      hobbies: {
        Tennis: {
          _ENGLISH: "Tennis",
          _GERMAN: "Tennis"
        },
        Reading: {
          _ENGLISH: "Reading",
          _GERMAN: "Lesen"
        },
        Movies: {
          _ENGLISH: "Movies",
          _GERMAN: "Filme schauen"
        },
        Puzzles: {
          _ENGLISH: "Puzzles",
          _GERMAN: "Puzzles"
        },
        Running: {
          _ENGLISH: "Running",
          _GERMAN: "Laufen"
        },
        Yoga: {
          _ENGLISH: "Yoga",
          _GERMAN: "Yoga"
        },
        Painting: {
          _ENGLISH: "Painting",
          _GERMAN: "Malen"
        },
        Surfing: {
          _ENGLISH: "Surfing",
          _GERMAN: "Surfen"
        },
        Trekking: {
          _ENGLISH: "Trekking",
          _GERMAN: "Trekking"
        },
        Space: {
          _ENGLISH: "Space",
          _GERMAN: "Space"
        },
        Workouts: {
          _ENGLISH: "Workouts",
          _GERMAN: "Workouts"
        },
        Carpentry: {
          _ENGLISH: "Carpentry",
          _GERMAN: "Tischlern"
        },
        Origami: {
          _ENGLISH: "Origami",
          _GERMAN: "Origami"
        },
        Knitting: {
          _ENGLISH: "Knitting",
          _GERMAN: "Basteln"
        },
        Cooking: {
          _ENGLISH: "Origami",
          _GERMAN: "Kochen"
        },
        Volunteer: {
          _ENGLISH: "Volunteer",
          _GERMAN: "Freiwilligenarbeit"
        },
      },
      register: {
        signup: {
          _ENGLISH: "Sign Up",
          _GERMAN: "Registrieren",
        },
        login: {
          _ENGLISH: "Log In",
          _GERMAN: "Anmelden",
        },
        enter_email_or_phone_number: {
          _ENGLISH: "Enter email or phone number",
          _GERMAN: "Email oder Mobil-Nr eingeben",
        },
        required_email_or_phone_number: {
          _ENGLISH: "Phone number or email is required",
          _GERMAN: "Mobilnummer oder Email benötigt",
        },
        by_signing_up_i_agree_to: {
          _ENGLISH: "By signing up, I agree to Avidii's",
          _GERMAN: "Mit  Klicken auf „Weiter“  akzeptiere  ich  die",
        },
        terms: {
          _ENGLISH: "Terms of Service",
          _GERMAN: "Terms of Service",
        },
        privacy: {
          _ENGLISH: "Privacy Policy",
          _GERMAN: "Privacy Policy",
        },
        or_login_with_social_media: {
          _ENGLISH: "Or login with social media",
          _GERMAN: "oder mit Social Media anmelden",
        },
        dont_have_any_of_the_above: {
          _ENGLISH: `"Dont have any of the above ? Login /\n Signup with your user name"`,
          _GERMAN: "",
        },
        verify_phone_number: {
          _ENGLISH: "Verify Phone Number",
          _GERMAN: "Mobilnummer verifizieren",
        },
        enter_code: {
          _ENGLISH: "Enter code",
          _GERMAN: "Code eingeben",
        },
        register_first: {
          _ENGLISH: "Please Register first before Logging in",
          _GERMAN: "Bitte zuerst Registrieren",
        }
      },
      login: {
        login: {
          _ENGLISH: "Login",
          _GERMAN: "Anmelden"
        },
        signup: {
          _ENGLISH: "Sign Up",
          _GERMAN: "Registrieren"
        },
        password: {
          _ENGLISH: "Password",
          _GERMAN: "Passwort"
        },
        forgot_username_password: {
          _ENGLISH: "Forgot UserName / Password",
          _GERMAN: "Benutzername/Passwort vergessen"
        },
        new_user: {
          _ENGLISH: "New User?",
          _GERMAN: "Neu?"
        },
        invalid_password: {
          _ENGLISH: "Password requires atleast 8 characters, one uppercase, one number and a special character.",
          _GERMAN: "Passwörter benötigen mindestens 8 Zeichen, ein Grosszeichen, eine Zahl und ein Sonderzeichen"
        }
      },
      scan_picture: {
        scan: {
          _ENGLISH: "Scan",
          _GERMAN: "Scannen"
        },
        upload: {
          _ENGLISH: "Upload",
          _GERMAN: "Hochladen"
        },
        take_a_picture: {
          _ENGLISH: "Take a picture",
          _GERMAN: "Foto machen"
        },
        record: {
          _ENGLISH: "Record",
          _GERMAN: "Audio-Aufnahme"
        },
        start_session: {
          _ENGLISH: "Start Session",
          _GERMAN: "Session Starten"
        },
        start_session_title: {
          _ENGLISH: "Start Session",
          _GERMAN: "Lernanfragen"
        },
      },
      setup_profile: {
        setup_profile: {
          _ENGLISH: "Set up Profile",
          _GERMAN: "Profil erstellen"
        },
        firstname: {
          _ENGLISH: "First Name	",
          _GERMAN: "Vorname"
        },
        lastname: {
          _ENGLISH: "Last Name",
          _GERMAN: "Nachname"
        }
      },
      create_password: {
        create_password: {
          _ENGLISH: "Create Password",
          _GERMAN: "Passwort erstellen"
        },
        enter_password: {
          _ENGLISH: "Enter Password",
          _GERMAN: "Passwort eingeben	"
        },
        confirm_password: {
          _ENGLISH: "Confirm Password",
          _GERMAN: "Passwort bestätigen"
        }
      },
      select_username: {
        select_username: {
          _ENGLISH: "Select Username",
          _GERMAN: "Benutzername auswählen"
        },
        brew_another_name: {
          _ENGLISH: "Brew Another Name",
          _GERMAN: "Anderen Namen zaubern"
        }
      },
      invite_parent: {
        invite_your_parent: {
          _ENGLISH: "Invite ONE OF your parent",
          _GERMAN: "Elternteil einladen"
        },
        please_add_mobile_number: {
          _ENGLISH: "Please add the mobile number of ONE OF your parent",
          _GERMAN: "Bitte Mobilnummer eines Elternteils angeben"
        },
        invite_parent_info: {
          _ENGLISH: "The first session is free. After your parent accepts your invitation and provides payment details, you can continue taking new sessions.",
          _GERMAN: "Deine  erste  Session  ist  gratis. Danach musst  du deine  Mutter  oder  deinen Vater  einladen,  um  avidii weiter  nutzen  zu können."
        },
        parent_phone_number: {
          _ENGLISH: "Parent phone number",
          _GERMAN: "Mobile Nummer Eltern"
        },
        parent_invite_sent: {
          _ENGLISH: "Invite Sent. Take a look at our videos until your parents accept your invite.",
          _GERMAN: "Einladung gesendet"
        },
        invite_parent: {
          _ENGLISH: "Invite Parent",
          _GERMAN: "Eltern einladen"
        }
      },
      session_history: {
        session_history: {
          _ENGLISH: "Session History",
          _GERMAN: "Sessions"
        }
      },
      alerts: {
        alerts: {
          _ENGLISH: "Alerts",
          _GERMAN: "Benachrichtigungen"
        }
      },
      my_profile: {
        my_profile: {
          _ENGLISH: "My Profile",
          _GERMAN: "Mein Profil"
        },
        profile_parents_themes: {
          _ENGLISH: "Profile, Parents",
          _GERMAN: "Profil, Eltern"
        },

        about_terms_privacy: {
          _ENGLISH: "About, Terms, Privacy",
          _GERMAN: "Über uns, AGB's, Datenschutz"
        },
        invite_friends: {
          _ENGLISH: "Invite friends",
          _GERMAN: "Freunde einladen"
        },
        resources: {
          _ENGLISH: "Resources",
          _GERMAN: "Ressourcen"
        },
        logout: {
          _ENGLISH: "Logout",
          _GERMAN: "Abmelden"
        }
      },
      profile_details: {
        parent_info: {
          _ENGLISH: "Parent Info",
          _GERMAN: "Infos der Eltern"
        },
        language: {
          _ENGLISH: "Language",
          _GERMAN: "Sprache"
        },
        account_balance: {
          _ENGLISH: "Account Balance",
          _GERMAN: "Verfügbares Guthaben"
        },
        topup: {
          _ENGLISH: "Credit-Code",
          _GERMAN: "Credit-Code"
        },
        topup_requested: {
          _ENGLISH: "Credit-Code",
          _GERMAN: "Credit-Code"
        },
        select_topup_amount: {
          _ENGLISH: "Select Top Up Amount",
          _GERMAN: "Aufzuladenen Betrag wählen"
        },
        invite_parent: {
          _ENGLISH: "Invite Parent",
          _GERMAN: "Eltern einladen"
        }
      },
      confirm_picture: {
        confirm_picture: {
          _ENGLISH: "Confirm Picture",
          _GERMAN: "Bestätigen"
        },
        retake_picture: {
          _ENGLISH: "Retake Picture",
          _GERMAN: "Erneut erfassen"
        },
        experience_alert: {
          _ENGLISH: "Your coaching experience will be best in a mobile tablet. Please use a tablet for better experience",
          _GERMAN: "Die Experience einer avidii Lernsession ist am besten auf einem Tablet. Bitte wechsel auf dein Tablet"
        },
        yes_ok: {
          _ENGLISH: "Yes, switch to Tablet",
          _GERMAN: "Ja, auf Tablet wechseln"
        },
        no_continue: {
          _ENGLISH: "No, Continue in mobile",
          _GERMAN: "Nein, weiter mit Handy"
        },
        notificaton_permission: {
          _ENGLISH: "Please enable Notifications in Settings to receive notifications from avidii",
          _GERMAN: "Damit wir dich mit einem Lerncoach verbinden können, benötigen wir die Erlaubnis, um Notifications zu senden. Bitte aktiviere diese in den Einstellungen deines Gerätes"
        }
      },
      new_session: {
        new_session: {
          _ENGLISH: "New Session",
          _GERMAN: "Lernsession"
        },
        select_subject: {
          _ENGLISH: "Select Subject",
          _GERMAN: "Fach auswählen"
        },
        physics: {
          _ENGLISH: "Physics",
          _GERMAN: "Physik"
        },
        chemistry: {
          _ENGLISH: "Chemistry",
          _GERMAN: "Chemie"
        },
        geography: {
          _ENGLISH: "Geography",
          _GERMAN: "Geografie"
        },
        maths: {
          _ENGLISH: "Maths",
          _GERMAN: "Mathe"
        },
        biology: {
          _ENGLISH: "Biology",
          _GERMAN: "Biologie"
        },
        history: {
          _ENGLISH: "History",
          _GERMAN: "Geschichte"
        },
        german: {
          _ENGLISH: "German",
          _GERMAN: "Deutsch"
        },
        french: {
          _ENGLISH: "French",
          _GERMAN: "Französisch"
        },
        italian: {
          _ENGLISH: "Italian",
          _GERMAN: "Italienisch"
        },
        english: {
          _ENGLISH: "English",
          _GERMAN: "Englisch"
        },
        other: {
          _ENGLISH: "Other",
          _GERMAN: "Andere"
        },
        languages: {
          _ENGLISH: "Languages",
          _GERMAN: "Sprachen"
        },
        please_wait_while_we_find_perfect_coach_for_you: {
          _ENGLISH: "Please wait while we find perfect coach for you",
          _GERMAN: "Bitte warten, wir suchen den ultimativen Coach"
        },
        confirmation: {
          _ENGLISH: "We will now connect to your coach",
          _GERMAN: "Wir verbinden dich jetzt mit einem Lerncoach"
        },
        invalid_coin_code: {
          _ENGLISH: "Hmm, that code did not work. Please enter a valid code.",
          _GERMAN: "Bitte gültigen Code eingeben."
        },
        enter_coin_code: {
          _ENGLISH: "Please enter avidii Credit-Code",
          _GERMAN: "avidii Credit-Code eingeben"
        },
        ask_code: {
          _ENGLISH: "Ask for code",
          _GERMAN: "Code anfragen"
        },
        goto_sessions: {
          _ENGLISH: "Unlock sessions",
          _GERMAN: "Sessions freischalten"
        },
        no_free_sessions: {
          _ENGLISH: "Oh oh, you have used all your free Sessions :-(",
          _GERMAN: "	Du hast all deine gratis Sessions verbraucht :-("
        }

      },
      edit_hobbies: {
        edit_hobbies_and_interests: {
          _ENGLISH: "Edit Hobbies & Interests",
          _GERMAN: "Ändern hobbies & Interessen"
        },
        select_hobbies: {
          _ENGLISH: "Select Hobbies",
          _GERMAN: "Hobbies auswählen"
        },
        add_some_more_hobbies_and_interests: {
          _ENGLISH: "Add some more hobbies & interests",
          _GERMAN: "Mehr Hobbies & Interessen hinzufügen"
        },
      },
      language_selector: {
        select_language: {
          _ENGLISH: "Select Language",
          _GERMAN: "Sprache auswählen"
        },
        german: {
          _ENGLISH: "German",
          _GERMAN: "Deutsch"
        },
        french: {
          _ENGLISH: "French",
          _GERMAN: "Französisch"
        },
        italian: {
          _ENGLISH: "Italian",
          _GERMAN: "Italienisch"
        },
        english: {
          _ENGLISH: "English",
          _GERMAN: "Englisch"
        },
      },
      rate_experience: {
        solved_problem: {
          _ENGLISH: "Did you solve the problem?",
          _GERMAN: "Wurde dein Problem gelöst?"
        },
        rate_coach: {
          _ENGLISH: "How good was your coach?",
          _GERMAN: "Wie gut war dein Coach?"
        },
        rate_experience: {
          _ENGLISH: "Were you happy with the experience?",
          _GERMAN: "Warst du happy mit der Erfahrung?"
        },
        rate_your_exp: {
          _ENGLISH: "Rate your experience",
          _GERMAN: "Bewerte deine Erfahrung"
        },
        rate_your_exp_with: {
          _ENGLISH: "Rate your experience with",
          _GERMAN: "Bewerte deine Erfahrung mit"
        },
      },
      select_avatar: {
        select_an_avatar: {
          _ENGLISH: "Select An Avatar",
          _GERMAN: "Avatar auswählen",
        }
      },
      liveboard: {
        finding_coach: {
          _ENGLISH: "Please wait while we search for the best coach",
          _GERMAN: "Bitte warten, wir suchen den besten Coach für dich",
        },
        finding_coach_waiting: {
          _ENGLISH: "It should not take long, waiting for the coach to accept",
          _GERMAN: "Warten, dass dein Coach annimmt, sollte nicht lang gehen...	",
        },
        please_wait_while_loading: {
          _ENGLISH: "Please wait while loading...",
          _GERMAN: "Bitte warten während es lädt...",
        },
        live_session: {
          _ENGLISH: "Live Session",
          _GERMAN: "Live Session",
        },
        end: {
          _ENGLISH: "End",
          _GERMAN: "beenden",
        },
        coach_not_found: {
          _ENGLISH: "Coach not Found! Contact support for help.",
          _GERMAN: "hmm, wir haben keinen Coach gefunden :( Bitte nimm Kontakt mit Support auf",
        },
        coach_not_found_for_session: {
          _ENGLISH: "Coach not found for your session.",
          _GERMAN: "Oh nein, wir haben keinen Coach gefunden :(",
        },
        coach_found: {
          _ENGLISH: "Coach found for your session!",
          _GERMAN: "Super! Wir haben den ultimativen Coach gefunden",
        },
        got_coach_request: {
          _ENGLISH: "Got Coach request for an Avidii Session!",
          _GERMAN: "Coach Anfrage für avidii Session",
        },
        session_is_in_progress_in_new_window: {
          _ENGLISH: "Session is in progress in new window",
          _GERMAN: "Session läuft in einem neuen Browser-tab",
        }
      }
    },
    COACH: {
      common: {
        search: {
          _ENGLISH: "Search",
          _GERMAN: "Suchen"
        },
        sort: {
          _ENGLISH: "Sort",
          _GERMAN: "Sortieren"
        },
        done: {
          _ENGLISH: "Done",
          _GERMAN: "Fertig"
        },
        select_country: {
          _ENGLISH: "Select Country",
          _GERMAN: "Land auswählen",
        },
        loading_common: {
          _ENGLISH: 'Loading... Please wait...',
          _GERMAN: "Lädt... Bitte warten"
        },
        physics: {
          _ENGLISH: "Physics",
          _GERMAN: "Physik"
        },
        chemistry: {
          _ENGLISH: "Chemistry",
          _GERMAN: "Chemie"
        },
        geography: {
          _ENGLISH: "Geography",
          _GERMAN: "Geografie"
        },
        maths: {
          _ENGLISH: "Maths",
          _GERMAN: "Mathe"
        },
        biology: {
          _ENGLISH: "Biology",
          _GERMAN: "Biologie"
        },
        history: {
          _ENGLISH: "History",
          _GERMAN: "Geschichte"
        },
        german: {
          _ENGLISH: "German",
          _GERMAN: "Deutsch"
        },
        french: {
          _ENGLISH: "French",
          _GERMAN: "Französisch"
        },
        italian: {
          _ENGLISH: "Italian",
          _GERMAN: "Italienisch"
        },
        english: {
          _ENGLISH: "English",
          _GERMAN: "Englisch"
        },
        other: {
          _ENGLISH: "Other",
          _GERMAN: "Andere"
        },
        and: {
          _ENGLISH: "and",
          _GERMAN: "und",
        },
        next: {
          _ENGLISH: "Next",
          _GERMAN: "Weiter",
        },
        back: {
          _ENGLISH: "Back",
          _GERMAN: "Zurück",
        },
        profile_set_up: {
          _ENGLISH: "Profile Set Up",
          _GERMAN: "Anderen Namen zaubern"
        },
        date_of_birth: {
          _ENGLISH: "Date of Birth",
          _GERMAN: "Geburstdatum"
        },
        educational_level: {
          _ENGLISH: "Education level",
          _GERMAN: "Schulstufe"
        },
        primary_school: {
          _ENGLISH: "Primary School",
          _GERMAN: "Primarschule"
        },
        middle_school: {
          _ENGLISH: "Middle School",
          _GERMAN: "Sek / 1-2 Langgymi"
        },
        high_school: {
          _ENGLISH: "High School",
          _GERMAN: "Kurzgymi / 3-6 Langgymi"
        },
        all_levels: {
          _ENGLISH: "All Levels",
          _GERMAN: "Alle Stufen"
        },
        select_your: {
          _ENGLISH: "Select your",
          _GERMAN: "Wähle"
        },
        profile_details: {
          _ENGLISH: "Profile Details",
          _GERMAN: "Profil Details"
        },
        username: {
          _ENGLISH: "User Name",
          _GERMAN: "Benutzername"
        },
        invite: {
          _ENGLISH: "Invite",
          _GERMAN: "einladen"
        },
        about_avidii: {
          _ENGLISH: "About Avidii",
          _GERMAN: "Über avidii"
        },
        privacy: {
          _ENGLISH: "Privacy",
          _GERMAN: "Datenschutz"
        },
        terms_and_conditions: {
          _ENGLISH: "Terms and Conditions",
          _GERMAN: "Terms of Service"
        },
        account_settings: {
          _ENGLISH: "Account Settings",
          _GERMAN: "Konto-Einstellungen"
        },
        profile_and_payment_details: {
          _ENGLISH: "Profile and Payment Details",
          _GERMAN: "Profil- und Zahlungseinstellungen"
        },
        invalid_phone_number: {
          _ENGLISH: "please enter valid phone number",
          _GERMAN: "Hmm... Sieht nicht nach einer richtigen Nummer aus",
        },
        please_wait_while_loading: {
          _ENGLISH: "Please wait while loading...",
          _GERMAN: "Bitte warten während es lädt...",
        },
        failed_otp: {
          _ENGLISH: "Failed to Send OTP",
          _GERMAN: "hmm, der Code konnte leider nicht gesendet werden.",
        },
        server_error: {
          _ENGLISH: "Server error, please try after some time",
          _GERMAN: "hmm, etwas hat nicht geklappt. Bitte versuch es später nochmal",
        },
        invalid_otp: {
          _ENGLISH: "Invalid Otp, please try again",
          _GERMAN: "hmm, der Code konnte leider nicht gesendet werden. Bitte versuch es nochmal",
        },
        thanks_for_registering: {
          _ENGLISH: "You have successfully registered as a Coach. Please wait for us to validate and confirm you as a coach. You will hear back from us. Thanks, you will be logged out now.",
          _GERMAN: "Deine Registrierung ist bei uns eingegangen. Unser Team validiert sie und du wirst benachrichtigt, wenn du dich anmelden kannst. Du wirst jetzt ausgeloggt.",
        },
        end: {
          _ENGLISH: "End",
          _GERMAN: "beenden",
        }
      },
      register: {
        login: {
          _ENGLISH: "Log In",
          _GERMAN: "Anmelden",
        },
        signup: {
          _ENGLISH: "Sign Up",
          _GERMAN: "Registrieren",
        },
        enter_phone_number: {
          _ENGLISH: "Enter phone number",
          _GERMAN: "Mobilnummer eingeben",
        },
        by_signing_up_i_agree_to: {
          _ENGLISH: "By signing up, I agree to Avidii's",
          _GERMAN: "Mit  Klicken auf „Weiter“  akzeptiere  ich  die",
        },
        terms: {
          _ENGLISH: "Terms of Service",
          _GERMAN: "Terms of Service",
        },
        privacy: {
          _ENGLISH: "Privacy Policy",
          _GERMAN: "Privacy Policy",
        },
        register_first: {
          _ENGLISH: "Please Register first before Logging in",
          _GERMAN: "Bitte zuerst Registrieren",
        }
      },
      verify: {
        verify_phone_number: {
          _ENGLISH: "Verify Phone Number",
          _GERMAN: "Mobilnummer verifizieren",
        },
        enter_code_sent_to_your_phone: {
          _ENGLISH: "Enter code sent to your phone",
          _GERMAN: "Erhaltenen Code eingeben",
        }
      },
      session_history: {
        session_history: {
          _ENGLISH: "Session History",
          _GERMAN: "Sessions"
        },
        search_for_studentname_subject: {
          _ENGLISH: "Search for student name, subject",
          _GERMAN: "Suche nach Lernenden"
        }
      },
      earnings: {
        earnings: {
          _ENGLISH: "Earnings",
          _GERMAN: "Einkommen"
        },
        session_trend: {
          _ENGLISH: "Session Trend",
          _GERMAN: "Session Trend"
        },
        earnings_trends: {
          _ENGLISH: "Earnings Trends (CHF)",
          _GERMAN: "Einkommen Trend"
        }
      },
      alerts: {
        alerts: {
          _ENGLISH: "Alerts",
          _GERMAN: "Benachrichtigungen"
        }
      },
      my_profile: {
        my_profile: {
          _ENGLISH: "My Profile",
          _GERMAN: "Mein Profil"
        },

        invite_coaches: {
          _ENGLISH: "Invite Coaches",
          _GERMAN: "Coaches einladen"
        },
        resources: {
          _ENGLISH: "Resources",
          _GERMAN: "Ressourcen"
        }

      },
      about_avidii: {
        learn_more: {
          _ENGLISH: "LEARN MORE",
          _GERMAN: "LEARN MORE"
        },
        privacy_and_policy: {
          _ENGLISH: "Privacy & Policy",
          _GERMAN: "Privacy & Policy"
        },
        terms_and_condition: {
          _ENGLISH: "Terms & Condition",
          _GERMAN: "Terms & Condition"
        }
      },
      account_settings: {
        coaching_request_alert: {
          _ENGLISH: "Coaching request alert",
          _GERMAN: "Coaching request alert"
        },
        avidii_tune: {
          _ENGLISH: "Avidii Tune",
          _GERMAN: "Avidii Tune"
        },
        custom: {
          _ENGLISH: "Custom",
          _GERMAN: "Custom"
        },
        email_and_phone_notifications: {
          _ENGLISH: "Email & Phone Notifications",
          _GERMAN: "Email & Phone Notifications"
        },
        email_notifications_for_new_coaching_alert: {
          _ENGLISH: "Email Notifications for new coaching alert",
          _GERMAN: "Email Notifications for new coaching alert"
        },
        mobile_notifications_for_new_coaching_alert: {
          _ENGLISH: "Mobile Notifications for new coaching alert",
          _GERMAN: "Mobile Notifications for new coaching alert"
        },
        logout: {
          _ENGLISH: "Logout",
          _GERMAN: "Abmelden"
        },
      },
      profile_and_payment_details: {
        firstname: {
          _ENGLISH: "First Name",
          _GERMAN: "Vorname"
        },
        lastname: {
          _ENGLISH: "Last Name",
          _GERMAN: "Nachname"
        },
        select_languages_spoken: {
          _ENGLISH: "Select Languages Spoken",
          _GERMAN: "Sprache auswählen"
        },
        address: {
          _ENGLISH: "Address",
          _GERMAN: "Adresse"
        },
        subjects_taught: {
          _ENGLISH: "Subjects Taught",
          _GERMAN: "Unterrichtete Themengebiete"
        },
        select_subjects_taught: {
          _ENGLISH: "Select subjects taught",
          _GERMAN: "Unterrichtete Themengebiete auswählen"
        },
        edit: {
          _ENGLISH: "Edit",
          _GERMAN: "Ändern"
        },
        hobbies_and_interests: {
          _ENGLISH: "Hobbies & Interests",
          _GERMAN: "Hobbies & Interessen"
        },
        payment_details: {
          _ENGLISH: "Payment Details",
          _GERMAN: "Zahlungsdetails"
        },
        iban_number: {
          _ENGLISH: "IBAN Number",
          _GERMAN: "IBAN Nummer"
        },
        account_name: {
          _ENGLISH: "Account Name",
          _GERMAN: "Name des Kontoinhabers"
        },
        bank_name: {
          _ENGLISH: "Bank Name",
          _GERMAN: "Name der Bank"
        },
        save_changes: {
          _ENGLISH: "Save Changes",
          _GERMAN: "Änderungen speichern"
        },
        upload_profile_picture: {
          _ENGLISH: "Upload Profile Picture",
          _GERMAN: "Profilbild hochladen"
        },
        enter_bank_name: {
          _ENGLISH: "Enter bank name",
          _GERMAN: "Name der Bank"
        },
        street_name: {
          _ENGLISH: "Street Name",
          _GERMAN: "Strasse"
        },
        house_number: {
          _ENGLISH: "House Number",
          _GERMAN: "Hausnummer"
        },
        city: {
          _ENGLISH: "City",
          _GERMAN: "Stadt"
        },
        zipcode: {
          _ENGLISH: "Zip code",
          _GERMAN: "Postleitzahl"
        },
        country: {
          _ENGLISH: "Country",
          _GERMAN: "Land"
        },
        sessions: {
          _ENGLISH: "Sessions",
          _GERMAN: "Sessions"
        },
        setup_profile: {
          _ENGLISH: "Set up Profile",
          _GERMAN: "Profil erstellen"
        }
      },
      session_feedback: {
        session_feedback: {
          _ENGLISH: "Session Feedback",
          _GERMAN: "Session Feedback"
        },
        session_experience: {
          _ENGLISH: "Session Experience",
          _GERMAN: "Erfahrung"
        },
        rate_experience: {
          _ENGLISH: "Were you happy with the experience",
          _GERMAN: "Warst du happy mit der Erfahrung?"
        },
        student_feedback: {
          _ENGLISH: "Feedback for the student",
          _GERMAN: "Feedback"
        },
        overall_rating: {
          _ENGLISH: "Overall Rating",
          _GERMAN: "Allgemeine Bewertung"
        },
        additional_comments: {
          _ENGLISH: "Additional comments",
          _GERMAN: "weitere Bemerkungen"
        }
      },
      new_coach_request: {
        new_coach_request: {
          _ENGLISH: "New Coach Request",
          _GERMAN: "Neue Coachanfrage"
        },
        question_mode: {
          _ENGLISH: "Question Mode",
          _GERMAN: "Frage Typ"
        },
        subject: {
          _ENGLISH: "Subject",
          _GERMAN: "Schulfach"
        },
        level: {
          _ENGLISH: "Level",
          _GERMAN: "Schulstufe"
        },
        accept: {
          _ENGLISH: "ACCEPT",
          _GERMAN: "ANNEHMEN"
        },
        decline: {
          _ENGLISH: "DECLINE",
          _GERMAN: "ABLEHNEN"
        },
      },
      hobbies: {
        Tennis: {
          _ENGLISH: "Tennis",
          _GERMAN: "Tennis"
        },
        Reading: {
          _ENGLISH: "Reading",
          _GERMAN: "Lesen"
        },
        Movies: {
          _ENGLISH: "Movies",
          _GERMAN: "Filme schauen"
        },
        Puzzles: {
          _ENGLISH: "Puzzles",
          _GERMAN: "Puzzles"
        },
        Running: {
          _ENGLISH: "Running",
          _GERMAN: "Laufen"
        },
        Yoga: {
          _ENGLISH: "Yoga",
          _GERMAN: "Yoga"
        },
        Painting: {
          _ENGLISH: "Painting",
          _GERMAN: "Malen"
        },
        Surfing: {
          _ENGLISH: "Surfing",
          _GERMAN: "Surfen"
        },
        Trekking: {
          _ENGLISH: "Trekking",
          _GERMAN: "Trekking"
        },
        Space: {
          _ENGLISH: "Space",
          _GERMAN: "Space"
        },
        Workouts: {
          _ENGLISH: "Workouts",
          _GERMAN: "Workouts"
        },
        Carpentry: {
          _ENGLISH: "Carpentry",
          _GERMAN: "Tischlern"
        },
        Origami: {
          _ENGLISH: "Origami",
          _GERMAN: "Origami"
        },
        Knitting: {
          _ENGLISH: "Knitting",
          _GERMAN: "Basteln"
        },
        Cooking: {
          _ENGLISH: "Origami",
          _GERMAN: "Kochen"
        },
        Volunteer: {
          _ENGLISH: "Volunteer",
          _GERMAN: "Freiwilligenarbeit"
        },
        select_hobbies: {
          _ENGLISH: "Select Hobbies",
          _GERMAN: "Hobbies auswählen"
        },
        select_hobbies_description: {
          _ENGLISH: "Select Hobbies & Interests from the list below or add new ones in the text box",
          _GERMAN: "Hobbies und Interessen auswählen"
        },
        add_more_hobbies: {
          _ENGLISH: "Add some more hobbies & interests",
          _GERMAN: "Mehr Hobbies & Interessen hinzufügen"
        },
        enter_hobbies: {
          _ENGLISH: "Enter Hobbies and Interests",
          _GERMAN: "Hobbies und Interessen eingeben"
        }
      },
      whiteboard: {
        session_is_in_progress_in_new_window: {
          _ENGLISH: "Session is in progress in new window",
          _GERMAN: "Session läuft in einem neuen Browser-tab"
        }
      }
    }
  }

  getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  getTranslationByKey(key: string, page: string) {
    let word = this.getKeyWord(key, page);
    if (word) {
      return word;
    } else {
      console.log('word not found');
      return '';
    }
  }

  getTranslation(val: string, page: string) {
    console.log(val);
    if (!val || !page || val == '' || page == '') return;

    let key = this.getKeyByValue(this.KEYS[this.app], val.toLowerCase());
    if (key) {
      let word = this.getTranslationByKey(key, page);
      return word;
    } else {
      console.log('key not found');
    }
  }

  getKeyWord(key, page) {
    try {
      if (this.LOCALIZATION_KEYWORDS[this.app][page][key][this.userLanguage])
        return this.LOCALIZATION_KEYWORDS[this.app][page][key][this.userLanguage];
      else
        return '';
    } catch (err) {
      console.log("error: getKeyWord(key, page):key => ", key, "::  page=> ", page, " ::err=> ", err);
      return ''
    }
  }

  setLanguage(language) {
    localStorage.setItem('appLanguage', language);
    const langs = {
      English: '_ENGLISH',
      German: '_GERMAN',
      French: '_GERMAN',
      Italian: '_GERMAN'
    }
    this.userLanguage = langs[language];
  }

  getLanguage() {
    const langs = {
      English: '_ENGLISH',
      German: '_GERMAN',
      French: '_GERMAN',
      Italian: '_GERMAN'
    }

   let lang = this.getKeyByValue(langs, this.userLanguage);
   return lang ? lang : '';
  }

  setDefaultLanguage() {
    this.userLanguage = this.defaultLanguage;
  }

  setLocaleLanguage() {
    const _preferredLanguage = navigator.language.toLowerCase().split('-').join('_');
    const language = this._swizLocaleCodes.filter(lang => lang.lc.includes(_preferredLanguage));
    if (language.length > 0) {
      this.setLanguage(language[0].id);
    }
  }

  setDeviceLocaleLanguage(code) {
    const _preferredLanguage = code.toLowerCase().split('-').join('_');
    const language = this._swizLocaleCodes.filter(lang => lang.lc.includes(_preferredLanguage));
    if (language.length > 0) {
      this.setLanguage(language[0].id);
    }
  }
}


